export default __webpack_public_path__ + "a2504e81330af2c0f19a5006c5915be8.png";